import { isSubscriptionPurchase } from '@grandvisionhq/fun-products';

const isDeliveryIntervalValid = ({ configurations  })=>{
    const { purchaseType , subscriptionPurchaseConfigurations  } = configurations;
    if (isSubscriptionPurchase(purchaseType)) {
        return subscriptionPurchaseConfigurations.deliveryInterval !== null;
    }
    return undefined;
};
const isConfiguratorValid = (state)=>{
    const { deliveryInterval  } = state.configurator;
    return !!deliveryInterval.isValid;
};
const getInitialState = ({ purchaseType  })=>{
    return {
        configurations: {
            purchaseType,
            subscriptionPurchaseConfigurations: {
                deliveryInterval: null
            }
        },
        configurator: {
            invalidSubmissionsCount: undefined,
            isConfiguratorValid: true,
            deliveryInterval: {
                isValid: undefined,
                showError: false
            }
        }
    };
};

export { getInitialState, isConfiguratorValid, isDeliveryIntervalValid };
//# sourceMappingURL=helpers.js.map
